import JshModule from '@core/scripts/helper/jsh-module';
import {TrinityEvents} from './trinity.js';

function getVideoTrackingAttributes(moduleScope) {
    const teaserElement = moduleScope.closest('[jsh-trinity__view]');
    const teaserViewTracking = teaserElement?.getAttribute('jsh-trinity__view');

    if (!teaserViewTracking) {
        return null;
    }

    try {
        const parsedTracking = JSON.parse(teaserViewTracking.replace(/\r?\n|\r/g, ''));
        const teaserElementId = parsedTracking?.attributes?.teaserElementId;

        if (!teaserElementId) {
            return null;
        }

        return {
            teaserElementId,
            pageType: '',
            pageName: '',
            object: 'button',
        };
    } catch (error) {
        return null;
    }
}

do {
    const {moduleScope} = JshModule('teaser/video2');
    if (moduleScope !== null) {
        const video = moduleScope.parentNode.querySelector('video');
        const playPauseButton = moduleScope.querySelector('.play-pause-button');
        const playIcon = playPauseButton.querySelector('.play-icon');
        const pauseIcon = playPauseButton.querySelector('.pause-icon');
        const videoTrackingAttributes = getVideoTrackingAttributes(moduleScope);

        function updateButton() {
            if (video.paused) {
                playIcon.classList.add('active');
                pauseIcon.classList.remove('active');
                playPauseButton.setAttribute('aria-label', 'Video abspielen');
            } else {
                playIcon.classList.remove('active');
                pauseIcon.classList.add('active');
                playPauseButton.setAttribute('aria-label', 'Video pausieren');
            }
        }
        playPauseButton.addEventListener('click', function() {
            if (video.paused) {
                delete video.dataset.userPaused;
                video.play();
                if (videoTrackingAttributes) {
                    TrinityEvents.sendVideoActionClick({
                        ...videoTrackingAttributes,
                        clickName: 'start',
                    });
                }
                playIcon.classList.remove('active');
                pauseIcon.classList.add('active');
                playPauseButton.setAttribute('aria-label', 'Video pausieren');
            } else {
                video.dataset.userPaused = 'true';
                video.pause();
                if (videoTrackingAttributes) {
                    TrinityEvents.sendVideoActionClick({
                        ...videoTrackingAttributes,
                        clickName: 'pause',
                    });
                }
                playIcon.classList.add('active');
                pauseIcon.classList.remove('active');
                playPauseButton.setAttribute('aria-label', 'Video abspielen');
            }
        });
        video.addEventListener('play', updateButton);
        video.addEventListener('pause', updateButton);
        updateButton();
    }

} while (document.querySelector('[jsh-module="teaser/video2"]') !== null);
